import {useMainStore} from "@/store";
import BracketGuildRenamed from "./messages/Bracket/GuildRenamed";
import BracketSeasonPointsGained from "./messages/Bracket/SeasonPointsGained";
import BracketTest from "./messages/Bracket/Test";
import GuildApplicationApproved from "./messages/Guild/ApplicationApproved";
import GuildApplicationReceived from "./messages/Guild/ApplicationReceived";
import GuildApplicationRejected from "./messages/Guild/ApplicationRejected";
import GuildApplicationWithdrawn from "./messages/Guild/ApplicationWithdrawn";
import GuildBracketAssigned from "./messages/Guild/BracketAssigned";
import GuildChatMessageSent from "./messages/Guild/ChatMessageSent";
import GuildGuildDisbanded from "./messages/Guild/GuildDisbanded";
import GuildGuildMotdChanged from "./messages/Guild/GuildMotdChanged";
import GuildGuildRenamed from "./messages/Guild/GuildRenamed";
import GuildInviteAccepted from "./messages/Guild/InviteAccepted";
import GuildInviteDeclined from "./messages/Guild/InviteDeclined";
import GuildInviteRevoked from "./messages/Guild/InviteRevoked";
import GuildInviteSent from "./messages/Guild/InviteSent";
import GuildMemberDemoted from "./messages/Guild/MemberDemoted";
import GuildMemberKicked from "./messages/Guild/MemberKicked";
import GuildMemberOnline from "./messages/Guild/MemberOnline";
import GuildMemberOffline from "./messages/Guild/MemberOffline";
import GuildMemberPromoted from "./messages/Guild/MemberPromoted";
import GuildMemberQuit from "./messages/Guild/MemberQuit";
import GuildMemberSeasonPointsGained from "./messages/Guild/MemberSeasonPointsGained";
import GuildMemberVipPointsGained from "./messages/Guild/MemberVipPointsGained";
import GuildMembersHere from "./messages/Guild/MembersHere";
import GuildNewLeader from "./messages/Guild/NewLeader";
import GuildTest from "./messages/Guild/Test";
import GuildGuildVipPointsGained from "./messages/Guild/GuildVipPointsGained";
import GuildGuildVipPointsDecayed from "./messages/Guild/GuildVipPointsDecayed";
import SystemMaintenanceStart from "./messages/System/MaintenanceStart";
import SystemReferenceFile from "./messages/System/ReferenceFile";
import SystemSaleDeleted from "./messages/System/SaleDeleted";
import SystemSaleUpdated from "./messages/System/SaleUpdated";
import SystemSeasonClosing from "./messages/System/SeasonClosing";
import SystemSeasonScoring from "./messages/System/SeasonScoring";
import SystemSeasonActive from "./messages/System/SeasonActive";
import SystemSystemBroadcast from "./messages/System/SystemBroadcast";
import SystemTest from "./messages/System/Test";
import UserApplicationApproved from "./messages/User/ApplicationApproved";
import UserApplicationRejected from "./messages/User/ApplicationRejected";
import UserBanned from "./messages/User/Banned";
import UserInviteReceived from "./messages/User/InviteReceived";
import UserInviteRevoked from "./messages/User/InviteRevoked";
import UserBoutInviteAccepted from "./messages/User/BoutInviteAccepted";
import UserBoutInviteDeclined from "./messages/User/BoutInviteDeclined";
import UserBoutInviteReceived from "./messages/User/BoutInviteReceived";
import UserAchievementProgress from "./messages/User/AchievementProgress";
import UserAdRewardVerified from "./messages/User/AdRewardVerified";
import UserMultiplayerBout from "./messages/User/MultiplayerBout";
import UserSeasonRewards from "./messages/User/SeasonRewards";
import UserTest from "./messages/User/Test";
import NotificationAbilityPointsUpdated from "./notifications/AbilityPointsUpdated";
import NotificationApplicationReceived from "./notifications/ApplicationReceived";
import NotificationCharacterPointsUpdated from "./notifications/CharacterPointsUpdated";
import NotificationCurrenciesUpdated from "./notifications/CurrenciesUpdated";
import NotificationGuildDisbanded from "./notifications/GuildDisbanded";
import NotificationInviteReceived from "./notifications/InviteReceived";
import NotificationMemberKicked from "./notifications/MemberKicked";
import NotificationPurchasingPasscodeRemoved from "./notifications/PurchasingPasscodeRemoved";
import NotificationVipOverflow from "./notifications/VipOverflow";

export default class ChannelProvider
{
    static channels()
    {
        return [
            {
                name: 'bracket',
                nameSuffix: 'guild.bracket.id',
                messagePrefix: '.bracket.',
                method: 'join',
                // TODO: CHECK FOR ACTIVE SEASON/BRACKET
                gate: () => useMainStore().bracketed,
                messages: {
                    'season-points-gained': BracketSeasonPointsGained,
                    'guild-renamed': BracketGuildRenamed,
                    'test': BracketTest,
                },
            },
            {
                // TODO: EVENTS FOR BRACKET_ASSIGNED AND REWARDS_ALLOCATED
                name: 'guild',
                nameSuffix: 'guild.id',
                messagePrefix: '.guild.',
                method: 'join',
                gate: () => useMainStore().guilded,
                messages: {
                    'application-approved': GuildApplicationApproved,
                    'application-received': GuildApplicationReceived,
                    'application-rejected': GuildApplicationRejected,
                    'application-withdrawn': GuildApplicationWithdrawn,
                    'bracket-assigned': GuildBracketAssigned,
                    'chat-message-sent': GuildChatMessageSent,
                    'guild-disbanded': GuildGuildDisbanded,
                    'guild-motd-changed': GuildGuildMotdChanged,
                    'guild-renamed': GuildGuildRenamed,
                    'guild-vip-points-gained': GuildGuildVipPointsGained,
                    'guild-vip-points-decayed': GuildGuildVipPointsDecayed,
                    'invite-accepted': GuildInviteAccepted,
                    'invite-declined': GuildInviteDeclined,
                    'invite-revoked': GuildInviteRevoked,
                    'invite-sent': GuildInviteSent,
                    'member-demoted': GuildMemberDemoted,
                    'member-kicked': GuildMemberKicked,
                    'member-promoted': GuildMemberPromoted,
                    'member-quit': GuildMemberQuit,
                    'member-season-points-gained': GuildMemberSeasonPointsGained,
                    'member-vip-points-gained': GuildMemberVipPointsGained,
                    'new-leader': GuildNewLeader,
                    'guild-test': GuildTest,
                },
                presence: {
                    'here': GuildMembersHere,
                    'joining': GuildMemberOnline,
                    'leaving': GuildMemberOffline,
                },
            },
            {
                name: 'system',
                messagePrefix: '.system.',
                method: 'channel',
                gate: () => useMainStore().loggedIn,
                messages: {
                    'maintenance-start': SystemMaintenanceStart,
                    'reference-file': SystemReferenceFile,
                    'sale-deleted': SystemSaleDeleted,
                    'sale-updated': SystemSaleUpdated,
                    'season-closing': SystemSeasonClosing,
                    'season-scoring': SystemSeasonScoring,
                    'season-active': SystemSeasonActive,
                    'system-broadcast': SystemSystemBroadcast,
                    'system-test': SystemTest,
                },
            },
            {
                name: 'user',
                nameSuffix: 'id',
                messagePrefix: '.user.',
                method: 'private',
                gate: () => useMainStore().loggedIn,
                messages: {
                    'achievement-progress': UserAchievementProgress,
                    'ad-reward-verified': UserAdRewardVerified,
                    'application-approved': UserApplicationApproved,
                    'application-rejected': UserApplicationRejected,
                    'banned': UserBanned,
                    'invite-received': UserInviteReceived,
                    'invite-revoked': UserInviteRevoked,
                    'match-invite-accepted': UserBoutInviteAccepted,
                    'match-invite-declined': UserBoutInviteDeclined,
                    'match-invite-received': UserBoutInviteReceived,
                    'multiplayer-bout': UserMultiplayerBout,
                    'season-rewards': UserSeasonRewards,
                    'user-test': UserTest,
                },
                notifications: {
                    'ability-points-updated': NotificationAbilityPointsUpdated,
                    'application-received': NotificationApplicationReceived,
                    'character-points-updated': NotificationCharacterPointsUpdated,
                    'currencies-updated': NotificationCurrenciesUpdated,
                    'guild-disbanded': NotificationGuildDisbanded,
                    'invite-received': NotificationInviteReceived,
                    'member-kicked': NotificationMemberKicked,
                    'purchasing-passcode-removed': NotificationPurchasingPasscodeRemoved,
                    'vip-overflow': NotificationVipOverflow,
                },
            },
        ];
    }
}
